import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { Hotel } from "@/types/hotel";

interface HotelDeactivateDialogProps {
  hotel: Hotel | null;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const HotelDeactivateDialog: React.FC<HotelDeactivateDialogProps> = ({
  hotel,
  isPending,
  onOpenChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={hotel !== null} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("hotels.deactivate.title")}</DialogTitle>
          <DialogDescription>
            {t("hotels.deactivate.description", {
              name: hotel?.name ?? t("hotels.hotel"),
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            {t("hotels.deactivate.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending
              ? t("hotels.deactivate.deactivating")
              : t("hotels.deactivate.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
